export default [
    {
        "path": "/superdeer-activity/group-invite-202506/index",
        "name": "superdeer-activity/group-invite-202506/index",
        "meta": { "title": "邀友上团课 一起赢好礼", "headerType": 5 },
        component: () => import('../views/superdeer-activity/group-invite-202506/index.vue')
    },
    {
        "path": "/superdeer-activity/group-invite-202506/accept",
        "name": "superdeer-activity/group-invite-202506/accept",
        "meta": { "title": "邀请有礼", "headerType": 4 },
        component: () => import('../views/superdeer-activity/group-invite-202506/accept.vue')
    },
    {
        "path": "/superdeer-activity/group-invite-202506/receive",
        "name": "superdeer-activity/group-invite-202506/receive",
        "meta": { "title": "奖品领取确认", "headerType": 5 },
        component: () => import('../views/superdeer-activity/group-invite-202506/receive.vue')
    },
    {
        "path": "/superdeer-activity/group-invite-202506/vote",
        "name": "superdeer-activity/group-invite-202506/vote",
        "meta": { "title": "教练排行榜", "headerType": 4 },
        component: () => import('../views/superdeer-activity/group-invite-202506/vote.vue')
    },
    {
        "path": "/superdeer-activity/group-invite-202506/vote-user-rank",
        "name": "superdeer-activity/group-invite-202506/vote",
        "meta": { "title": "会员拉新榜", "headerType": 4 },
        component: () => import('../views/superdeer-activity/group-invite-202506/vote-user-rank.vue')
    },
    {
        "path": "/coach-own-member-coupon",
        "name": "coach-own-member-coupon",
        "meta": { "title": "领取教练专属优惠券", "headerType": 5 },
        component: () => import('../views/coach-own-member/coupon')
    },
    // {
    //   "path": "/invite-gift",
    //   "name": "invite-gift",
    //   "meta": { "title": "邀请有礼", "headerType": 5 },
    //   component: () => import('../views/invite-gift/index.vue')
    // },
    {
      "path": "/invite-gift",
      "name": "invite-gift",
      "meta": { "title": "邀请有礼", "headerType": 5 },
      component: () => import('../views/invite-gift/double11-2026/index.vue')
    },
    {
      "path": "/invite-gift/rank",
      "name": "invite-gift/rank",
      "meta": { "title": "邀新排行榜", "headerType": 4 },
      component: () => import('../views/invite-gift/double11-2026/rank.vue')
    },
    {
      "path": "/invite-gift",
      "name": "invite-gift",
      "meta": { "title": "邀请有礼", "headerType": 5 },
      component: () => import('../views/invite-gift/88-invite/index-202609.vue')
    },
    {
        "path": "/invite-gift/receive",
        "name": "invite-gift/receive",
        "meta": { "title": "奖品领取确认", "headerType": 5 },
        component: () => import('../views/invite-gift/receive.vue')
    },
    {
        "path": "/invite-gift/experience",
        "name": "invite-gift/experience",
        "meta": { "title": "超鹿诚邀体验", "headerType": 5 },
        component: () => import('../views/invite-gift/experience.vue')
    },
    {
        "path": "/invite-gift/shijijinglong",
        "name": "invite-gift-shijijinglong",
        "meta": { "title": "邀请有礼", "headerType": 5 },
        component: () => import('../views/invite-gift/shijijinglong/index.vue')
    },
    {
        "path": "/superdeer-activity/coupon/index/:id",
        "name": "superdeer-activity/coupon/index",
        "meta": { "title": "领券", "headerType": 5 },
        component: () => import('../views/superdeer-activity/coupon/index.vue')
    },
    {//通用，需传入3参数
        "path": "/superdeer-activity/receive-reward/index",
        "name": "superdeer-activity/receive-reward/index",
        "meta": { "title": "领奖", "headerType": 5 },
        component: () => import('../views/superdeer-activity/receiveReward/index.vue')
    },
    {
        "path": "/coach-will-survey",
        "name": "coach-will-survey",
        "meta": { "title": "我要做教练", "headerType": 5 },
        component: () => import('../views/coach-will-survey/index.vue')
    },
    {
        path: '/coach-feedback/index',
        name: 'coach/feedback/index',
        meta: { title: '教练意见反馈', "headerType": 5 },
        component: () => import('@/views/coachFeedback/index.vue')
    },
    {
        path: '/coach-feedback/record',
        name: 'coach/feedback/record',
        meta: { title: '教练反馈记录', "headerType": 5 },
        component: () => import('../views/coachFeedback/record.vue')
    },
    {
        path: '/coach-feedback/detail',
        name: 'coach/feedback/detail',
        meta: { title: '教练反馈详情', "headerType": 5 },
        component: () => import('../views/coachFeedback/detail.vue')
    },
    {
        path: '/superdeer-activity/annual-report-2025/index',
        name: 'superdeer-activity/annual-report-2025/index',
        meta: { title: '年度报告', headerType: 5 },
        component: () => import(/* webpackChunkName: "annual-report-2025" */ '../views/superdeer-activity/annual-report-2025/index')
    },
    {
        path: '/superdeer-activity/annual-report-2025/calender',
        name: 'superdeer-activity/annual-report-2025/calender',
        meta: { title: '运动日历报告', headerType: 5 },
        component: () => import(/* webpackChunkName: "annual-report-2025" */ '../views/superdeer-activity/annual-report-2025/calender.vue')
    },
    {
        path: '/group-questionnaire/index',
        name: 'group-questionnaire/index',
        meta: { title: '运动需求问卷', headerType: 5 },
        component: () => import('../views/superdeer-activity/group-questionnaire/index')
    },
    {
        path: '/group-questionnaire/recommend',
        name: 'group-questionnaire/recommend',
        meta: { title: '推荐课程', headerType: 5 },
        component: () => import('../views/superdeer-activity/group-questionnaire/recommend')
    },
    {
        "path": "/superdeer-activity/spring-awakening-2025/red-envelope",
        "name": "superdeer-activity/spring-awakening-2025/red-envelope",
        "meta": { "title": "超鹿开工红包", "headerType": 5 },
        component: () => import(/* webpackChunkName: "sell" */'../views/superdeer-activity/spring-awakening-2025/red-envelope')
    },
    {
        "path": "/superdeer-activity/spring-awakening-2025/receive-reward",
        "name": "superdeer-activity/spring-awakening-2025/receive-reward",
        "meta": { "title": "奖品领取确认", "headerType": 5 },
        component: () => import(/* webpackChunkName: "sell" */'../views/superdeer-activity/spring-awakening-2025/receiveReward/index')
    },
    {
        "path": "/superdeer-activity/spring-awakening-2025/send",
        "name": "superdeer-activity/spring-awakening-2025/send",
        "meta": { "title": "甩春膘 迎盛夏", "headerType": 4 },
        component: () => import(/* webpackChunkName: "sell" */'../views/superdeer-activity/spring-awakening-2025/send')
    },
    {
        "path": "/superdeer-activity/coach-punching-202503/index",
        "name": "superdeer-activity/coach-punching-202503/index",
        "meta": { "title": "私教打卡", "headerType": 4 },
        component: () => import('../views/superdeer-activity/coach-punching-202503/index')
    },
    {
        "path": "/superdeer-activity/private-invite-202503/index",
        "name": "superdeer-activity/private-invite-202503/index",
        "meta": { "title": "私教老带新", "headerType": 5 },
        component: () => import('../views/superdeer-activity/private-invite-202503/index')
    },
    {
        "path": "/superdeer-activity/private-invite-202503/accept",
        "name": "superdeer-activity/private-invite-202503/accept",
        "meta": { "title": "邀请有礼", "headerType": 5 },
        component: () => import('../views/superdeer-activity/private-invite-202503/accept.vue')
    },
    {
        "path": "/superdeer-activity/group-activity-202510/index",
        "name": "superdeer-activity/group-activity-202510/index",
        "meta": { "title": "开盲盒抽奖", "headerType": 5 },
        component: () => import('../views/superdeer-activity/group-activity-202510/index.vue')
    },
    {
        "path": "/superdeer-activity/group-activity-202510/question",
        "name": "superdeer-activity/group-activity-202510/question",
        "meta": { "title": "答题抽奖", "headerType": 5 },
        component: () => import('../views/superdeer-activity/group-activity-202510/index2.vue')
    },
    // 双12活动
    {
    "path": "/superdeer-activity/double12-2025/deposit/index",
    "name": "superdeer-activity/double12-2025/deposit/index",
    "meta": { "title": "超鹿双十二", "headerType": 4 },
    // component: () => import(/* webpackChunkName: "anni2025" */'../views/superdeer-activity/double12-2025/deposit/index.vue')
    component: () => import('../views/superdeer-activity/double12-2025/main/index.vue')
    },
    {
        "path": "/superdeer-activity/double12-2025/deposit/send",
        "name": "superdeer-activity/double12-2025/deposit/send",
        "meta": { "title": "超鹿周年庆大促", "headerType": 4 },
        component: () => import('../views/superdeer-activity/double12-2025/deposit/send')
    },
    {
        "path": "/superdeer-activity/double12-2025/main",
        "name": "superdeer-activity/double12-2025/main",
        "meta": { "title": "2026超鹿春醒", "headerType": 4 },
        component: () => import('../views/superdeer-activity/double12-2025/main/index.vue')
    },
    {
        "path": "/superdeer-activity/double12-2025/shop",
        "name": "superdeer-activity/double12-2025/shop",
        "meta": { "title": "2026超鹿春醒·热销商品", "headerType": 5 },
        component: () => import('../views/superdeer-activity/double12-2025/main/shop.vue')
    },
    // 双12返场VIP
    {
    "path": "/superdeer-activity/double12-2025-2/deposit/index",
    "name": "superdeer-activity/double12-2025-2/deposit/index",
    "meta": { "title": "超鹿双十二", "headerType": 4 },
    component: () => import('../views/superdeer-activity/double12-2025-2/main/index.vue')
    },
    {
        "path": "/superdeer-activity/double12-2025-2/deposit/send",
        "name": "superdeer-activity/double12-2025-2/deposit/send",
        "meta": { "title": "超鹿双12大促", "headerType": 4 },
        component: () => import('../views/superdeer-activity/double12-2025-2/deposit/send')
    },
    {
        "path": "/superdeer-activity/double12-2025-2/main",
        "name": "superdeer-activity/double12-2025-2/main",
        "meta": { "title": "超鹿双十二", "headerType": 4 },
        component: () => import('../views/superdeer-activity/double12-2025-2/main/index.vue')
    },
    {
        "path": "/superdeer-activity/double12-2025-2/shop",
        "name": "superdeer-activity/double12-2025-2/shop",
        "meta": { "title": "超鹿双十二·热销商品", "headerType": 5 },
        component: () => import('../views/superdeer-activity/double12-2025-2/main/shop.vue')
    },
    {
        "path": "/superdeer-activity/private-invite-202512/index",
        "name": "superdeer-activity/private-invite-202512/index",
        "meta": { "title": "私教老带新", "headerType": 5 },
        component: () => import('../views/superdeer-activity/private-invite-202512/index')
    },
    {
        "path": "/superdeer-activity/private-invite-202512/accept",
        "name": "superdeer-activity/private-invite-202512/accept",
        "meta": { "title": "邀请有礼", "headerType": 5 },
        component: () => import('../views/superdeer-activity/private-invite-202512/accept.vue')
    },
    // 春醒活动
    {
        "path": "/superdeer-activity/spring-awakening-2026/return",
        "name": "superdeer-activity/spring-awakening-2026/return",
        "meta": { "title": "召回专区", "headerType": 4 },
        component: () => import('../views/superdeer-activity/spring-awakening-2026/return.vue')
    },
    {
        "path": "/superdeer-activity/spring-awakening-2026/sale",
        "name": "superdeer-activity/spring-awakening-2026/sale",
        "meta": { "title": "积分兑好礼", "headerType": 4 },
        component: () => import('../views/superdeer-activity/spring-awakening-2026/sale.vue')
    },
    {
        "path": "/superdeer-activity/spring-awakening-2026/rank",
        "name": "superdeer-activity/spring-awakening-2026/rank",
        "meta": { "title": "积分排行榜", "headerType": 4 },
        component: () => import('../views/superdeer-activity/spring-awakening-2026/rank.vue')
    },
    {
        "path": "/superdeer-activity/spring-awakening-2026/getGift",
        "name": "superdeer-activity/spring-awakening-2026/getGift",
        "meta": { "title": "奖品领取确认", "headerType": 5 },
        component: () => import('../views/superdeer-activity/spring-awakening-2026/getGift.vue')
    },
    // 火花活动
    {
        "path": "/superdeer-activity/fire-activity",
        "name": "superdeer-activity/fire-activity",
        "meta": { "title": "锻炼不能停", "headerType": 4 },
        component: () => import('../views/superdeer-activity/fire-activity/index.vue')
    },
    {
        "path": "/superdeer-activity/fire-activity/accept",
        "name": "superdeer-activity/fire-activity/accept",
        "meta": { "title": "组队攒火花", "headerType": 4 },
        component: () => import('../views/superdeer-activity/fire-activity/accept.vue')
    },
    // 能量豆活动
    {
        "path": "/superdeer-activity/fire-activity-fz",
        "name": "superdeer-activity/fire-activity-fz",
        "meta": { "title": "攒能量豆", "headerType": 4 },
        component: () => import('../views/superdeer-activity/fire-activity-fz/index.vue')
    },
    {
        "path": "/superdeer-activity/fire-activity-fz/accept",
        "name": "superdeer-activity/fire-activity-fz/accept",
        "meta": { "title": "组队攒能量豆", "headerType": 4 },
        component: () => import('../views/superdeer-activity/fire-activity-fz/accept.vue')
    },
    {
        "path": "/superdeer-activity/fire-activity-fz/rank",
        "name": "superdeer-activity/fire-activity-fz/rank",
        "meta": { "title": "能量豆排行榜", "headerType": 4 },
        component: () => import('../views/superdeer-activity/fire-activity-fz/rank.vue')
    },
    // 火花活动v2
    {
        "path": "/superdeer-activity/fire-activity-v2",
        "name": "superdeer-activity/fire-activity-v2",
        "meta": { "title": "攒火花", "headerType": 4 },
        component: () => import('../views/superdeer-activity/fire-activity-v2/index.vue')
    },
    {
        "path": "/superdeer-activity/fire-activity-v2/accept",
        "name": "superdeer-activity/fire-activity-v2/accept",
        "meta": { "title": "组队攒火花", "headerType": 4 },
        component: () => import('../views/superdeer-activity/fire-activity-v2/accept.vue')
    },
    {
        "path": "/superdeer-activity/fire-activity-v2/rank",
        "name": "superdeer-activity/fire-activity-v2/rank",
        "meta": { "title": "火花排行榜", "headerType": 4 },
        component: () => import('../views/superdeer-activity/fire-activity-v2/rank.vue')
    },
    {
        "path": "/superdeer-activity/double11-2026/deposit/send",
        "name": "superdeer-activity/double11-2026/deposit/send",
        "meta": { "title": "超鹿双11运动季", "headerType": 4 },
        component: () => import('../views/superdeer-activity/double11-2026/deposit/send.vue')
    },
    // 2026福州马拉松备赛活动
    {
        "path": "/superdeer-activity/fuzhou-marathon/index",
        "name": "superdeer-activity/fuzhou-marathon/index",
        "meta": { "title": "备赛来超鹿 赢福马名额", "headerType": 4 },
        component: () => import('../views/superdeer-activity/fuzhou-marathon/index.vue')
    },
    {
        "path": "/superdeer-activity/fuzhou-marathon/rank",
        "name": "superdeer-activity/fuzhou-marathon/rank",
        "meta": { "title": "跑值排行榜", "headerType": 4 },
        component: () => import('../views/superdeer-activity/fuzhou-marathon/rank.vue')
    },
    {
        "path": "/superdeer-activity/fuzhou-marathon/receive",
        "name": "superdeer-activity/fuzhou-marathon/receive",
        "meta": { "title": "奖品领取确认", "headerType": 5 },
        component: () => import('../views/superdeer-activity/fuzhou-marathon/receive.vue')
    },
    {
        "path": "/superdeer-activity/fuzhou-marathon/receive-store",
        "name": "superdeer-activity/fuzhou-marathon/receive-store",
        "meta": { "title": "奖品领取确认", "headerType": 5 },
        component: () => import('../views/superdeer-activity/fuzhou-marathon/receive-store.vue')
    },
    // 2026双11活动
    {
        "path": "/superdeer-activity/double11-2026/return",
        "name": "superdeer-activity/double11-2026/return",
        "meta": { "title": "召回专区", "headerType": 4 },
        component: () => import('../views/superdeer-activity/double11-2026/return.vue')
    },
    {
        "path": "/superdeer-activity/double11-2026/sale",
        "name": "superdeer-activity/double11-2026/sale",
        "meta": { "title": "积分兑好礼", "headerType": 4 },
        component: () => import('../views/superdeer-activity/double11-2026/sale.vue')
    },
    {
        "path": "/superdeer-activity/double11-2026/check-in",
        "name": "superdeer-activity/double11-2026/check-in",
        "meta": { "title": "社群打卡", "headerType": 4 },
        component: () => import('../views/superdeer-activity/double11-2026/check-in.vue')
    },
    {
        "path": "/superdeer-activity/double11-2026/getGift",
        "name": "superdeer-activity/double11-2026/getGift",
        "meta": { "title": "奖品领取确认", "headerType": 4 },
        component: () => import('../views/superdeer-activity/double11-2026/getGift.vue')
    },
    {
        "path": "/superdeer-activity/double11-2026/return",
        "name": "superdeer-activity/double11-2026/return",
        "meta": { "title": "召回专区", "headerType": 4 },
        component: () => import('../views/superdeer-activity/double11-2026/return.vue')
    },
    {
        "path": "/superdeer-activity/double11-2026/return2",
        "name": "superdeer-activity/double11-2026/return2",
        "meta": { "title": "召回专区", "headerType": 4 },
        component: () => import('../views/superdeer-activity/double11-2026/return2.vue')
    },
]
